// src/components/ProtectedRoute.tsx
import { Navigate, useNavigate } from "react-router-dom";
import { ReactNode, useEffect } from "react";

import Loader from "../components/ui/Loader";
import { User } from "../types/features/User";
import { KAFINTECH_URL } from "../config/urls";
import useAuth from "../hooks/features/auth/useAuth";

type ProtectedRouteProps = {
  children: ReactNode;
  allowedRoles: User["role"][];
};

export default function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const userRole = user?.role;
  const navigate = useNavigate();

  // Redirection uniquement après chargement et si pas d'utilisateur
  useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [loading, user]);

  // Pendant le chargement ou si pas d'utilisateur, on affiche le loader
  if (loading || !user) {
    return <Loader />;
  }

  if (userRole && !allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
